import { useAuth as e } from "../hooks/useAuth.mjs";
import "react";
import { Fragment as t, jsx as n } from "react/jsx-runtime";
//#region src/components/AuthRestricted.tsx
var r = ({ children: r, fallback: i = null }) => {
	let { isAuthenticated: a } = e();
	return /* @__PURE__ */ n(t, { children: a ? r : i });
};
//#endregion
export { r as AuthRestricted };
